var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPawPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 12.5C25.2179 12.5 27.0833 10.6345 27.0833 8.33334C27.0833 6.03215 25.2179 4.16667 22.9167 4.16667C20.6155 4.16667 18.75 6.03215 18.75 8.33334C18.75 10.6345 20.6155 12.5 22.9167 12.5Z",
    stroke: "#19263F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5007 20.8333C39.8018 20.8333 41.6673 18.9679 41.6673 16.6667C41.6673 14.3655 39.8018 12.5 37.5007 12.5C35.1995 12.5 33.334 14.3655 33.334 16.6667C33.334 18.9679 35.1995 20.8333 37.5007 20.8333Z",
    stroke: "#19263F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 37.5C43.9679 37.5 45.8333 35.6345 45.8333 33.3333C45.8333 31.0322 43.9679 29.1667 41.6667 29.1667C39.3655 29.1667 37.5 31.0322 37.5 33.3333C37.5 35.6345 39.3655 37.5 41.6667 37.5Z",
    stroke: "#19263F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7503 20.8333C20.1182 20.8333 21.4728 21.1028 22.7366 21.6263C24.0004 22.1498 25.1487 22.917 26.116 23.8843C27.0833 24.8516 27.8505 25.9999 28.374 27.2637C28.8975 28.5275 29.167 29.8821 29.167 31.25V38.5417C29.1664 40.2843 28.5417 41.9691 27.4062 43.2909C26.2706 44.6127 24.6992 45.4842 22.9765 45.7473C21.2539 46.0105 19.4939 45.6481 18.0155 44.7256C16.537 43.8032 15.4378 42.3817 14.917 40.7188C14.0281 37.8507 12.1531 35.9722 9.29196 35.0833C7.62984 34.5628 6.20897 33.4644 5.28646 31.987C4.36395 30.5097 4.00074 28.7509 4.26256 27.0289C4.52437 25.307 5.39392 23.7356 6.71385 22.5992C8.03377 21.4628 9.71689 20.8364 11.4586 20.8333H18.7503Z",
    stroke: "#19263F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawPrint);
export default __webpack_public_path__ + "static/media/paw-print.d4179d75be5208cbee12361d03d269ae.svg";
export { ForwardRef as ReactComponent };